/*******************************************************************************
  설  명 : 메인화면
  작성자 : 송영석
  작성일 : 2020-05-18
*******************************************************************************/
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

import { CommonService } from '@app/service/common.service';
import { MainService } from '@app/home/service/main.service';
import { CookieService } from 'ngx-cookie-service';

import { fromEvent, Observable, Subscription } from "rxjs";

import { ToastrService } from 'ngx-toastr';
import { O2OZCMS } from '@app/components/o2oz-cms/o2oz-cms.component';

import * as $ from 'jquery';
import * as moment from 'moment';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent extends O2OZCMS implements OnInit {

  /*******************************************************************************
    설명 : 전역 변수 선언부
  *******************************************************************************/
  @ViewChild('carousel', { static: true }) carousel: ElementRef;

  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;

  public isMobile: any = false;

  public menu: any = {
    depth1_id: 1,
    depth2_id: 1,
    depth1_nm: '협회소개',
    depth2_nm: '협회 회장 인사말',
    depth3_nm: ''
  };

  public information_active: string;

  public link_list = '';

  public boardData: any = [
    [], [], [], [], [], []
  ];

  public month: any = '01';

  public bannerList: any = [];
  public bannerBottomList: any = [];
  public popupList: any = [];
  public is_popup_preview: any = [];

  public currentSlide = 0;

  public SwiperConfigInterface_notice: SwiperConfigInterface = {
    slidesPerView: 1,
    spaceBetween: 0,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
  };

  public SwiperConfigInterface_link: SwiperConfigInterface = {
    slidesPerView: 4,
    spaceBetween: 0,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next1',
      prevEl: '.swiper-button-prev1',
    },
  };

  /*******************************************************************************
    설  명 : 생성자
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  constructor(
    router: Router,
    commonService: CommonService,
    activatedRoute: ActivatedRoute,
    toastrService: ToastrService,
    private mainService: MainService,
    private cookieService: CookieService,
  ) {
    // 상위 클래스에 router 전달
    super(router, commonService, activatedRoute, toastrService);
  }

  /*******************************************************************************
    설  명 : 데이터 초기화
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  ngOnInit() {
/*
    // 향후 팝업 기능 구현 필요
    if( ! this.cookieService.check('pop_20200129') )
      window.open('/assets/popup/20200129/p20200129.html','p20200129','toolbar=no,location=no,directories=no,status=no,menubar=no, scrollbars=no,resizable=yes,copyhistory=false, width=700,height=775,top=0,left=0');
    if( ! this.cookieService.check('pop_20200228') )
      window.open('/assets/popup/20200228/p20200228.html','p20200228','toolbar=no,location=no,directories=no,status=no,menubar=no, scrollbars=no,resizable=yes,copyhistory=false, width=640,height=950,top=0,left=0');
*/
    if ( window.innerWidth <= 720 ) {
      this.SwiperConfigInterface_link.slidesPerView = 2.5;
      this.isMobile = true;
    }

    this.resizeObservable$ = fromEvent(window, 'resize')
    this.resizeSubscription$ = this.resizeObservable$.subscribe( evt => {
      if ( window.innerWidth <= 720 ) {
        this.SwiperConfigInterface_link.slidesPerView = 2.5;
        this.isMobile = true;
      }
    })

    this.information_active = '1';

    this.month = moment().format('M');

    this.getBoardInfo();

    // 배너 및 팝업
    this.getBannerList();
    this.getBoardPopupList();
  }

  ngOnDestroy() {
    this.resizeSubscription$.unsubscribe()
  }

  ngAfterViewInit() {
    setTimeout( () => {
      document.getElementById('carousel-control-next').click();
    }, 5000);
  }

  /*******************************************************************************
    설  명 : 바로가기 클릭시
    입력값 :
    리턴값 :
  *******************************************************************************/
  onLink( linkIndex ) {
    if (this.link_list == linkIndex) {
      this.link_list = '0';
    } else {
      this.link_list = linkIndex;
    }
  }

  /*******************************************************************************
    설  명 : 게시판 정보 가져오기
    입력값 :
    리턴값 :
  *******************************************************************************/
  getBoardInfo() {
    // 공지사항 가져오기
    this.mainService.getBoardNotice().then( response => {
      if( response.ResultCode ) {
        this.boardData[0] = response.data;
      } else {
        this.boardData[0] = [];
      }
    });

    // 정책 홍보 가져오기
    this.mainService.getBoardKraiasns().then( response => {
      if( response.ResultCode ) {
        this.boardData[1] = response.data;
      } else {
        this.boardData[1] = [];
      }
    });

    // 냉난방공조 뉴스
    this.mainService.getBoardNews().then( response => {
      if( response.ResultCode ) {
        this.boardData[2] = response.data;
      } else {
        this.boardData[2] = [];
      }
    });

    // 환경ㆍ세미나 안내
    this.mainService.getBoardSeminar().then( response => {
      if( response.ResultCode ) {
        this.boardData[3] = response.data;
      } else {
        this.boardData[3] = [];
      }
    });

    // 회원사 소식
    this.mainService.getBoardCompanyNews().then( response => {
      if( response.ResultCode ) {
        this.boardData[4] = response.data;
      } else {
        this.boardData[4] = [];
      }
    });

    // 회원사 일정
    this.mainService.getBoardCompanyMonth().then( response => {
      if( response.ResultCode ) {
        this.boardData[5] = response.data;
      } else {
        this.boardData[5] = [];
      }
    });

  }

  /*******************************************************************************
    설  명 : li 표시 체크
    입력값 : index, key
    리턴값 : true / false
  *******************************************************************************/
  checkLi( index, key ) {
    if( index == '' ) index = 0;

    if( Math.floor( index / 8 ) == (key - 1) ) return true;
    else return false;
  }

  /*******************************************************************************
    설  명 : 마지막 페이지 번호 체크
    입력값 : index = boardData array index
    리턴값 : 페이지 번호 체크
  *******************************************************************************/
  checkLastPage( index ) {
    let tmp = [];
    let last = Math.floor( this.boardData[index].length / 8 ) + 1;

    for( let i = 0; i < last; i++ ) {
      tmp.push(i+1);
    }

    return tmp;
  }

  getLastPage( index ) {
    return Math.floor( this.boardData[index].length / 8 ) + 1;
  }

  /*******************************************************************************
    설  명 : 배너 리스트 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getBannerList() {
    this.mainService.getBannerList().then( response => {
      if ( response.ResultCode ) {
        this.bannerList = response.data.filter(row => row.type === '0' && row.use_yn === '1' && row.group === '0');
        this.bannerBottomList = response.data.filter(row => row.type === '0' && row.use_yn === '1' && row.group === '1')
          .sort(function (a, b) {
            if (a.sort_order > b.sort_order) {
              return 1;
            }
            if (a.sort_order < b.sort_order) {
              return -1;
            }
            // a must be equal to b
            return 0;
          });
      } else {
        this.bannerList = [];
        this.bannerBottomList = [];
      }
    });
  }

  /*******************************************************************************
    설  명 : 날짜 비교
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  dateDiff(sdate, edate) {
    sdate = sdate.split('-').join('');
    edate = edate.split('-').join('');
    const today = moment().format('YYYY') + moment().format('MM') + moment().format('DD');

    if (sdate > today || edate < today) {
      return true;
    }
  }

  /*******************************************************************************
    설  명 : 팝업 리스트 정보 가져오기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getBoardPopupList() {
    this.mainService.getPopupList( {board_id: 'popup', limit: '0'} ).then( response => {
      if ( response.ResultCode) {
        if ( response.data.length > 0 ) {
          response.data.forEach( row => {

            if (this.dateDiff(row.notice_sdate, row.notice_edate)) {
              return true;
            }

            if ( this.getPopupToday(row.board_seq) ) {
              if ( row.layer_popup == true ) {
                row.is_popup_preview = true;
                this.popupList.push(row);
              } else {
                const url = 'http://ref.o2oz.net/api/popup/popup.php?board_id=' + row.board_id + '&board_seq=' + row.board_seq;
                window.open(url, '', 'resizable=no, toolbar=no, scrollbars=auto, menubar=no, directories=no, location=no, width='+row.popup_width+', height='+(parseInt(row.popup_height, 10) + 108)+', left='+row.screen_x+', top=' + row.screen_y );
              }
            }
          });
        }
      }
    });
  }

  /*******************************************************************************
    설  명 : 팝업 오늘 더 이상 보지 않기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  getPopupToday( boardSeq ) {
    if ( this.cookieService.get( 'popup' + boardSeq ) == 'hidden' ) {
      return false;
    } else {
      return true;
    }
  }

  /*******************************************************************************
    설  명 : 팝업 오늘 더 이상 보지 않기
    입력값 : 없음
    리턴값 : 없음
  *******************************************************************************/
  setPopupToday( row ) {
    this.cookieService.set( 'popup' + row.board_seq, 'hidden', 1 );

    row.is_popup_preview = false;
  }
}
